<template>
  <button id="vk_auth" class="authorization-vk" @click="showAuthorizationForm">
    <span class="authorization-icon">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="#ffffff" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.785 16.241s.288-.032.436-.194c.136-.148.132-.427.132-.427s-.02-1.304.576-1.496c.588-.19 1.341 1.26 2.14 1.818.605.422 1.064.33 1.064.33l2.137-.03s1.117-.071.587-.964c-.043-.073-.308-.661-1.588-1.87-1.34-1.264-1.16-1.059.453-3.246.983-1.332 1.376-2.145 1.253-2.493-.117-.332-.84-.244-.84-.244l-2.406.015s-.178-.025-.31.056c-.13.079-.213.262-.213.262s-.382 1.03-.89 1.907c-1.07 1.85-1.499 1.948-1.674 1.832-.407-.267-.305-1.075-.305-1.649 0-1.793.267-2.54-.521-2.733-.262-.065-.454-.107-1.123-.114-.858-.009-1.585.003-1.996.208-.274.136-.485.44-.356.457.159.022.519.099.71.363.246.341.237 1.107.237 1.107s.142 2.11-.33 2.371c-.325.18-.77-.187-1.725-1.865-.489-.859-.859-1.81-.859-1.81s-.07-.176-.198-.272c-.154-.115-.37-.151-.37-.151l-2.286.015s-.343.01-.469.161c-.112.135-.009.413-.009.413s1.79 4.258 3.817 6.403c1.858 1.967 3.968 1.838 3.968 1.838z"/>
      </svg>
    </span>
    VK
  </button>
</template>

<script>
import * as VKID from "@vkid/sdk";

export default {
  emits: ['authorizedSuccess'],
  props: {
    authEnabled: Boolean
  },
  mounted() {
    VKID.Config.init({
      app: Number(process.env.VUE_APP_VK_APP_ID),
      redirectUrl: process.env.VUE_APP_VK_REDIRECT_URL,
      responseMode: VKID.ConfigResponseMode.Callback,
      source: VKID.ConfigSource.LOWCODE,
      scope: 'email phone',
    });
  },

  methods: {
    showAuthorizationForm() {
      VKID.Auth.login()
          .then(payload => VKID.Auth.exchangeCode(payload.code, payload.device_id))
          .then(tokens => {
            this.$emit('authorizedSuccess', 'vk', {
              access_token: tokens.access_token,
              user_id: tokens.user_id,
            });
          })
          .catch(e => {
            console.error('VK auth error', e);
          });
    }
  }
}
</script>

<style scoped>
</style>
